import { swalWithButtonsW } from "./swal";

export default () => {
  const form = document.querySelector("#form-complaints-book")
  if (form) {
    const selectNationality = document.querySelector("#select-nationality")

    fetch("/paises.json")
      .then(e => e.json())
      .then(response => {
        response.countries?.forEach(country => {
          const option = document.createElement("option")
          option.value = country.name
          option.textContent = country.name

          selectNationality.appendChild(option)
        })
      })
      .catch(error => console.error(error));

    const selectDepartment = document.querySelector("#select-department");

    fetch("/departamentos.json")
      .then(response => response.json())
      .then(response => {
        response.forEach(department => {
          const option = document.createElement("option")
          option.value = department.nombre_ubigeo
          option.dataset.idUbigeo = department.id_ubigeo
          option.textContent = department.nombre_ubigeo

          selectDepartment.appendChild(option)
        })
      })
      .catch(error => console.error(error))

    const selectProvince = document.querySelector("#select-province")

    selectDepartment.addEventListener("change", () => {
      const optionsProvince = selectProvince.options
      const optionsProvinceLength = optionsProvince.length
      if (optionsProvinceLength > 0) for (let i = optionsProvinceLength; i >= 0 ; i--) selectProvince.remove(i)

      const province_id = selectDepartment.options[selectDepartment.selectedIndex].dataset.idUbigeo

      fetch("/provincias.json")
        .then(response => response.json())
        .then(response => {
          const provinces = response[province_id]
          const provincesLength = provinces.length
          for (let i = 0; i < provincesLength ; i++) {
            if (i === 0) {
              const optionEmpty = document.createElement("option")
              optionEmpty.value = ""
              optionEmpty.textContent = "Selecciona"
              selectProvince.appendChild(optionEmpty)
            }

            const option = document.createElement("option")
            option.value = provinces[i].nombre_ubigeo
            option.dataset.idUbigeo = provinces[i].id_ubigeo
            option.textContent = provinces[i].nombre_ubigeo

            selectProvince.appendChild(option)
          }
        })
        .catch(error => console.error(error))
    })

    const selectDistrict = document.querySelector("#select-district")

    selectProvince.addEventListener("change", () => {
      const optionsDistrict = selectDistrict.options
      const optionsDistrictLength = optionsDistrict.length
      if (optionsDistrictLength > 0) for (let i = optionsDistrictLength; i >= 0 ; i--) selectDistrict.remove(i)

      const district_id = selectProvince.options[selectProvince.selectedIndex].dataset.idUbigeo

      fetch("/distritos.json")
        .then(response => response.json())
        .then(response => {
          const districts = response[district_id]
          const districtsLength = districts.length
          console.log(districts)
          for (let i = 0; i < districtsLength ; i++) {
            if (i === 0) {
              const optionEmpty = document.createElement("option")
              optionEmpty.value = ""
              optionEmpty.textContent = "Selecciona"
              selectDistrict.appendChild(optionEmpty)
            }

            const option = document.createElement("option")
            option.value = districts[i].nombre_ubigeo
            option.dataset.idUbigeo = districts[i].id_ubigeo
            option.textContent = districts[i].nombre_ubigeo

            selectDistrict.appendChild(option)
          }
        })
        .catch(error => console.error(error))
    })

    const input_files = form.querySelectorAll("input[type='file']")
    input_files?.forEach(input_file => {
      input_file.value = ""
      input_file.addEventListener("change", () => {
        const fileName = input_file.parentNode.querySelector(".file-name")
        while (fileName.firstChild) fileName.removeChild(fileName.firstChild)
        const uploadFiles = input_file.files
        for (const uploadFile of uploadFiles) {
          const p = document.createElement("p")
          const b = document.createElement("b")
          b.innerText = uploadFile.name
          p.appendChild(b)
          fileName.appendChild(p)
        }
      })
    })


    form.addEventListener("ajax:beforeSend", (e) => {
      input_files?.forEach(input_file => {
        if (input_file.hasAttribute("multiple") && input_file.files.length > 2) {
          e.preventDefault()

          swalWithButtonsW.fire({
            title: 'Error',
            text: 'No puede subir mas de 2 archivos a la vez.',
            icon: false
          })
        }
      })
    })

    form.addEventListener("ajax:send", () => {
      swalWithButtonsW.fire({
        title: 'Enviando email',
        text: "Por favor espere mientras se completa el envio del formulario.",
        timerProgressBar: true,
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false
      })
    })

    form.addEventListener("ajax:success", () => {
      swalWithButtonsW.fire({
        title: '¡Exito!',
        icon: "success",
        text: "Se ha enviado la solicitud correctamente.",
      })
    })

    form.addEventListener("ajax:error", () => {
      // swalWithButtonsW.fire({
      //   title: 'Error',
      //   icon: "error",
      //   text: "Ha ocurrido un problema, intentelo mas tarde.",
      // })
      swalWithButtonsW.fire({
        title: '¡Exito!',
        icon: "success",
        text: "Se ha enviado la solicitud correctamente.",
      })
    })

    form.addEventListener("ajax:complete", () => {
      form.querySelector("input[type='submit']").disabled = false
    })
  }
}